import React from 'react';
import {programSections} from "../components/helpers/programSections";
const TreatmentPage = () => {
    return (
        <div className="treatment-page-container">
            <header className="page-header">
                <h1>Методы лечения санатория "Узбекистан"</h1>
            </header>

            <div className="sections-wrapper">
                {programSections.map((section, sectionIndex) => (
                    <section className={`treatment-section ${sectionIndex === 0 ? 'first-section' : ''}`} key={sectionIndex}>
                        <h2 className="treatment-section-title">{section.title}</h2>

                        <div className="treatment-cards-list">
                            {section.subItems.map((item, itemIndex) => (
                                <div className="treatment-card" key={itemIndex}>
                                    <div className="treatment-card-content">
                                        <div className="treatment-card-banner">
                                            {item.title}
                                        </div>
                                        <h3 className="treatment-item-title">{item.title}</h3>
                                        <p className="treatment-item-description">{item.description}</p>
                                    </div>
                                    <div className="treatment-card-image-container">
                                        {item.imageUrl && <img src={item.imageUrl} alt={item.title} className="treatment-card-image"/>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                ))}
            </div>
        </div>
    );
};

export default TreatmentPage;